<template>
  <section class="content-header">
    <h1>Informe de Fichajes</h1>
  </section>

</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';


export default {
  

  data() {
    return {
      respuesta: null,
      error: ''
    };
  },

  methods: {
    

    async cargarprueba() {
      this.error = '';
      this.respuesta = null;
      try {
        const api = new PwgsApi();
        const body = {
          tipo_respuesta: 'json',
          id_usuario: '',
          fecha_inicio: '01/10/2024',
          fecha_fin: '08/09/2026'
        };
        const resp = await api.post('informes/modulos-fichajes-informe', body);
        console.log('respuesta:', resp);
        this.respuesta = JSON.stringify(resp, null, 2);
      } catch (e) {
        console.error(e);
        this.error = e.message || String(e);
      }
    }
  },

  mounted() {
    this.cargarprueba();
    
  }
};
</script>